
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/4w/Euler/Storm-Ev",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/4w/Euler/Storm-Ev/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/4w/Euler/Storm-Ev"])
      });
    }
  